import styled from '@emotion/styled/macro';

import { COLUMN_IDS } from './keys';

export const Container = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: '5px 0',
  [`& [data-column="${COLUMN_IDS.STATUS}"]`]: {
    minWidth: 100,
  },
  [`& [data-column="${COLUMN_IDS.DATE}"]`]: {
    minWidth: 180,
  },
  [`
  & [data-column="${COLUMN_IDS.ID}"],
  & [data-column="${COLUMN_IDS.ORDERS}"]
  `]: {
    minWidth: 120,
    maxWidth: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& [data-column="${COLUMN_IDS.FIAT_AMOUNT}"]`]: {
    maxWidth: 300,
    '& .MuiTableSortLabel-root': {
      flexDirection: 'row-reverse',
    },
  },
}));
